import { z } from 'zod';

export const narrativeSectionKeySchema = z.enum([
  'website',
  'outstanding-needs',
  'feedback',
  'upcoming-meetings',
  'creative-strategy',
  'budget-current',
  'budget-target',
  'budget-increase',
  'budget-projected',
]);

export type NarrativeSectionKey = z.infer<typeof narrativeSectionKeySchema>;

export const narrativeBlockSchema = z.object({
  sectionKey: narrativeSectionKeySchema,
  richText: z.string().max(10_000),
  updatedAt: z.string().nullish(),
  // Set server-side when an AE edits the block. A locked block is never
  // rewritten by strategy regeneration.
  locked: z.boolean().optional(),
});

export type NarrativeBlock = z.infer<typeof narrativeBlockSchema>;
